export const getToken = () => {
  const tokenString = localStorage.getItem("access_token");
  return tokenString ? { Authorization: tokenString } : null;
};
